import api from 'api/apiInstance';

export function clientMotivationCentreImageApi(path: string) {
  return {
    path,
    DELETE: () => api.delete(path),
  };
}
